import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';

export default function Navigation(props) {
  const { auth, logout } = props;
  return (
    <Navbar className="nav-menu" variant="light">
      <Container>
          <a href={'/'} aria-label="Know Your Home Value, eAlerts Home Page">
            <img
              src="/know_your_home_value_sm.png"
              height="60"
              className="kyhvlogo"
              alt="Know Your Home Value Small Logo"
            />
          </a>
          {auth && (
            <Nav className="justify-content-end">
              <Nav.Link onClick={logout}>Logout</Nav.Link>
            </Nav>
          )}
      </Container>
    </Navbar>
  );
}
